module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hollow-dots-spinner",
    style: (_vm.spinnerStyle)
  }, _vm._l((_vm.dotsStyles), function(ds, index) {
    return _c('div', {
      key: index,
      staticClass: "dot",
      style: (ds)
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ed29e824!./~/vue-loader/lib/selector.js?type=template&index=0!./~/epic-spinners/src/components/lib/HollowDotsSpinner.vue
// module id = 1027
// module chunks = 1